var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5674 0C41.2402 0 53.1347 11.8946 53.1348 26.5674C53.1348 41.2402 41.2402 53.1348 26.5674 53.1348C11.8946 53.1347 0 41.2402 0 26.5674C7.60221e-05 11.8947 11.8947 7.60267e-05 26.5674 0ZM26.5674 5.31348C14.8292 5.31355 5.31355 14.8292 5.31348 26.5674C5.31348 38.3056 14.8292 47.8212 26.5674 47.8213C38.3057 47.8213 47.8213 38.3057 47.8213 26.5674C47.8212 14.8292 38.3056 5.31348 26.5674 5.31348ZM43.0586 17.8193L21.2539 39.624L11.4053 29.7744L15.1621 26.0176L21.2539 32.1094L39.3008 14.0625L43.0586 17.8193Z",
    fill: "#0C8117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.fa10376b1a4a997dfcb655cb15ffe53e.svg";
export { ForwardRef as ReactComponent };